import React,{useState, useEffect} from 'react'
import styled from "styled-components";
import AddedProduct from "./AddedProduct";
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import numeral from 'numeral';
import { Add } from '@mui/icons-material';
import { auth, firestore } from '../firebase';
import { v4 as uuid } from 'uuid';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function Checkout() {
  const [{basket, user}, dispatch]= useStateValue();
  const history = useHistory();
  const orderTotal = getBasketTotal(basket);
  const formattedOrderTotal = numeral(orderTotal).format('$0,0.00');
  const [userAddress, setUserAddress] = useState('');

  const addAddress = (e) => {
  e.preventDefault();
  const address = prompt("Enter Your Address");

  if (address !== null && address.trim() !== "") {
    const addressRef = firestore.collection("customers").doc(user?.displayName);

    addressRef
      .update({ address: address })
      .then(() => {
        alert("Address Updated");
      })
      .catch((error) => {
        console.error('Error updating address:', error);
      });
  } else {
    alert("Address cannot be null or empty");
  }
};

  useEffect(() => {
      const getAddressData = async () => {
        try {
          const addressDoc = await firestore.collection("customers").doc(user?.displayName).get();
  
          if (addressDoc.exists) {
            const data = addressDoc.data();
            setUserAddress(data?.address || 'No address found');
          } else {
            console.log('Document not found');
          }
        } catch (error) {
          console.error('Error fetching address:', error);
        }
      };
  
      getAddressData();
    }, [user?.displayName]);

  const paymentCard = (e) => {
    const orderRef = firestore.collection("orders");
  
    // Loop through each item in the basket
    basket.forEach((item, index) => {
      const orderUid = uuid();
      const orderId = `${user?.displayName}_${orderUid}`; // Add an index to make each order unique
      const orderData = {
        itemOrdered: item.title,
        name: user?.displayName,
        uid: auth?.currentUser?.uid,
        orderId: orderUid,
        method: "Card",
        price: item?.price,
        orderDate: new Date(),
        image: item?.image,
        status: "",
      };
  
      // Create a document in the "orders" collection for each item
      orderRef.doc(orderId).set(orderData)
        .then(() => {
          dispatch({
            type: 'EMPTY_BASKET',
          });
          localStorage.removeItem('basket');
          console.log(`Successfully ordered item ${orderUid}`);
          history.push("/my-account")
        })
        .catch((error) => {
          console.error(`Error placing order for item ${orderUid}:`, error);
        });
    });
  }

    const paymentCash = (e) => {
      const orderRef = firestore.collection("orders");

      // Loop through each item in the basket
      basket.forEach((item, index) => {
        const orderUid = uuid();
        const orderId = `${user?.displayName}_${orderUid}`; // Add an index to make each order unique
        const orderData = {
          itemOrdered: item.title,
          name: user?.displayName,
          uid: auth?.currentUser?.uid,
          orderId: orderUid,
          method: "Cash",
          price: item?.price,
          orderDate: new Date(),
          image: item?.image,
          status: "",
        };

        // Create a document in the "orders" collection for each item
        orderRef.doc(orderId).set(orderData)
          .then(() => {
            dispatch({
              type: 'EMPTY_BASKET',
            });
            localStorage.removeItem('basket');
            console.log(`Successfully ordered item ${orderUid}`);
            history.push("/my-account")
          })
          .catch((error) => {
            console.error(`Error placing order for item ${orderUid}:`, error);
          });
      });

    // Display an alert after all orders are processed
    alert("Successfully Ordered");
  };

  return (
    <Container>
        <Content>
        <Item>
            <h4>Your Cart {user?.displayName} </h4>
            <AddedProductRow>
            {basket.map(item => (
          <AddedProduct
          id={item.id}
          title={item.title}
          image={item.image}
          price={item.price}
          />
        ))}
            </AddedProductRow>
        </Item>
        <Payment>
            <h4>Payment :</h4>
            <>
         <h5>Order total : <strong>({formattedOrderTotal}) ({basket?.length} Items)</strong></h5>
            </>
        </Payment>
        <Delivery>
            <h4>Delivery Address / Delivery Time</h4>
            <p onClick={addAddress}>{userAddress || `Add your Delivery`}
            <br />
            This item/items will be delivered in the next 2 days</p>
        </Delivery>
        <PaymentOptions style={{justifyContent: "space-around"}} >
            <br />
        <Master>
        <button class="mastercard" onClick={paymentCard}>Pay ({formattedOrderTotal}) with Card
        </button>
        </Master>
        <Gpay>
        <button class="gpay" onClick={paymentCash}>Pay ({formattedOrderTotal}) with Cash</button>
        </Gpay>
        </PaymentOptions>
        </Content>
        <br />
    </Container>
  )
}

const Container = styled.div`
  width: 70vw;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 0 0 rgb(0 0 0 / 20%);
  display: flex;
  background: white;
  margin-left: 15%;
  margin-top: 3%;
  flex-direction: column;

  @media(max-width: 768px) {
    width: 97vw;
    margin: 0;
  }
`;

const Content = styled.div`
  align-items: center;
  justify-content: center;
`;

const Delivery = styled.div`
  display: flex;
  width: 70vw;
  flex-direction: column;
  text-align: center;
  justify-content: space-between;
  border-bottom: 1px solid black;

  @media(max-width: 768px) {
    width: 100vw;
  }

  h4 {
    text-decoration: underline;
  }

  p{
   margin-top: -1%;
  }

`;

const Item = styled.div`
  border-bottom: 1px solid black;

  h4 {
    text-decoration: underline;
    text-align: center;
    margin-top: 5%;
  }
`;

const AddedProductRow = styled.div`
  display: flex;
  background: white;
  flex-direction: column;
  align-items: center;
`;

const Payment = styled.div`
  display: flex;
  width: 70vw;
  justify-content: space-around;
  border-bottom: 1px solid black;

  @media(max-width: 768px) {
    width: 100vw;
  }

  h4 {
    font-size: 17px;

    @media(max-width: 768px) {
      margin-left: 3%;
    }
  }
  h5 {
    font-weight: 500;
    font-size: 15px;

    @media(max-width: 768px) {
      margin-right: 6%;
    }
  }

  @media(max-width: 768px) {
    justify-content: space-between;
  }
`;

const PaymentOptions = styled.div`
  width: 70vw;
  display: flex;
  text-align: center;

  @media(max-width: 890px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  button {
    height: 6vh;
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    margin-top: 7%;
    border: 1px solid gray;
    background-color: white;

    @media(max-width: 890px) {
      width: 80vw;
    }

    @media(max-width: 768px) {
        width: 55vw;
    }
  }
`;

const Master= styled.div`
  width: 20vw;
  button {
    background: gold;
    color: white;
}
`;

const Paypal = styled.div`
  width: 20vw;
  button {
    background: blue;
    color: white;
}
`;

const Gpay = styled.div`
  width: 20vw;
  button {
    background: green;
    color: white;
  }
`;

const Apay = styled.div`
  width: 20vw;
  button {
    background: black;
    color: white;
}
`;

const Stripe = styled.div`
  width: 20vw;
  button {
    background: purple;
    color: white;
  }
`;

export default Checkout